module.exports = __webpack_public_path__ + "media/images/menu/star_clusters-69c8b85b89ba10b982ab574983cf367f.jpg";